import { alpha } from '@mui/material';
import { clamp } from '@ui/style/clamp-calculator';
import { between } from '@ui/style/style';
import { useResponsive } from '@ui/style/useResponsive';
import { bottomNavigation, headerHeight, spaceAboveHeader, spaceBelowHeader } from '@ui/style/variables';
const usePermissionStyles = () => {
    const { isMobileIpadNavigation, isMobile } = useResponsive();
    const headingHeight = 48;
    const spaceBelowHeading = 34;
    const pageEndPadding = 8;
    const statusHeight = 44;
    const spaceAfterStatus = 12;
    const containerEndPadding = 8;
    const cardContainerHeight = `${spaceAboveHeader + headerHeight + spaceBelowHeader + headingHeight + spaceBelowHeading + pageEndPadding + statusHeight + spaceAfterStatus + containerEndPadding}px`;
    const cardContainerHeightMobile = `${headerHeight + spaceAboveHeader + headingHeight + containerEndPadding + bottomNavigation + 60}px`;
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            gap: isMobileIpadNavigation ? 1 : 4.25,
            pb: 1,
            px: isMobileIpadNavigation ? 0 : clamp.calculate(8, 32),
            overflow: 'hidden',
            height: '100%'
        },
        mobileScreenHeader: {
            between,
            flexDirection: 'row',
            backgroundColor: (theme) => alpha(theme.palette.common.black, 0.2),
            px: clamp.calculate(8, 32),
            height: '100%',
            paddingBottom: 1
        },
        mobileScreenHeadingButton: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: 1,
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: isMobile ? 'wrap' : undefined
        },
        mobileScreenGroupedButtonBox: {
            display: 'flex',
            gap: 1,
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'flex-end'
        },
        permissionContainer: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            px: 1,
            maxHeight: isMobileIpadNavigation
                ? `calc(100dvh - ${cardContainerHeightMobile})`
                : `calc(100dvh - ${cardContainerHeight})`,
            gap: (theme) => theme.spacing(2)
        },
        bottomPermissionDrawer: {
            p: 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        }
    };
};
export default usePermissionStyles;
